import { CircularProgress, createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Field, Form, Formik } from 'formik';
import FormTextField from '../../common/form/FormTextField';
import PropTypes from 'prop-types';
import FormPasswordField from '../../common/form/FormPasswordField';
import CommonButton from '../../common/CommonButton';

const styles = createStyles(theme => ({
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    position: 'relative',
    '& button': {
      width: 130,
      height: 44,
    },
  },
  circularProgress: {
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute',
    right: 42,
    top: 2,
    '& svg': {
      width: 20,
    },
  },
}));

const LoginForm = React.forwardRef((props, ref) => {
  const { classes, onSubmit } = props;
  
  return (
    <Formik
      initialValues={{
        username: '',
        password: '',
      }}
      onSubmit={onSubmit}>
      {({ isSubmitting, dirty }) => (
        <Form className={classes.root}>
        
          <Field
            autoFocus
            name="username"
            component={FormTextField}
            disabled={isSubmitting}
            label={(
              <FormattedMessage
                id="form.login.field.login.label"
                defaultMessage="Login"
              />
            )}
          />
          
          <Field
            name="password"
            component={FormPasswordField}
            disabled={isSubmitting}
            label={(
              <FormattedMessage
                id="form.login.field.password.label"
                defaultMessage="Password"
              />
            )}
          />
        
          <div className={classes.buttonWrapper}>
            <CommonButton
              type="submit"
              label={!isSubmitting
                ? <FormattedMessage
                  id="form.login.button.submit"
                  defaultMessage="Login"
                />
                : <CircularProgress className={classes.circularProgress} />
              }
              disabled={isSubmitting || !dirty}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
});

LoginForm.propTypes = {
  classes: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default withStyles(styles, { name: 'LoginForm' })(LoginForm);
